import React, { useMemo, useState } from "react";

import { useViewport } from 'components/general/useViewPort'

import Label from "components/general/Label";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStop, faCircle, faCaretUp, faCaretLeft, faCaretRight, faCaretDown,
} from "@fortawesome/free-solid-svg-icons";
import { findArray } from 'helpers/utils';
import { NocMemo as Noc } from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import Target from "components/common/targets/target";
import TargetsModalWindow from "components/common/targets/targetsModal";
import { getEvent } from "helpers/rsc"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

function OlympicRoundTeam({ data }) {

  const { mirs_rsc, mirs_competition } = useUrlFriendlyToParameters()
  const { breakPoint } = useViewport();

  let responsive = breakPoint === 'xl' || breakPoint === 'xxl' ? OlympicRoundTeamXL({ data }) : OlympicRoundTeamSM({ data })


  if ((mirs_competition === 'PG2024' && getEvent(mirs_rsc) !== 'INDIVIDR99030-----' && getEvent(mirs_rsc) !== 'TEAMR---99030-----')
    || (mirs_competition === 'EG2023' && (getEvent(mirs_rsc) === 'INDIVIDC----------' || getEvent(mirs_rsc) === 'TEAM2C------------')))
    responsive = breakPoint === 'xl' || breakPoint === 'xxl' ? OlympicRoundTeamXLPar({ data }) : OlympicRoundTeamSMPar({ data })

  return (
    <>{responsive}</>
  )
}

function OlympicRoundTeamXLPar({ data }) {
  const dataFilter = getDataFormated(data)
  const { mirs_competition } = useUrlFriendlyToParameters()
  let config = data?.results?.extendedInfos
  let sets = config?.find(row => row?.ei_code === 'SET')
  let setsNum = sets?.ei_value;
  let arrows = config?.find(row => row?.ei_code === 'ARROW_NUM')?.ei_value;
  let arrowsSetNum = sets?.extensions?.find(row => row?.eie_code === 'ARROW_NUM' && row?.eie_pos === '1')?.eie_value;
  let listArrowsSets = [];
  let sizeTarget = 300;
  let rowDefault = [];
  const currentPos = data?.results?.extendedInfos.find(row => row?.ei_code === 'CURRENT')?.ei_pos;
  for (let i = 1; i <= setsNum; i++) {
    rowDefault.push({ index: String(i), status: false })
  }
  rowDefault.push({ index: 'SO', status: false })
  const [stateRow, setStateRow] = useState({
    settings: [...rowDefault]
  });


  const handelClick = (set) => {
    setStateRow({
      ...stateRow, settings: stateRow.settings.map(item =>
        item.index === set ? { ...item, state: !item.state } : item
        //{ index: set, state: !stateRow.find(row => row?.index === set) })
      )
    })
  }

  for (let i = 0; i < arrowsSetNum; i++) {
    listArrowsSets.push(<th key={'arrow-' + i} scope="col" className="text-center w-5" > {i + 1}</th >)
  }

  return (
    <>
      <div className="mirs-page-container">
        <table className="table">
          <thead>
            <tr>
              <th scope="colgroup" className="text-center w-5" rowSpan="2"><Label data="HeaderEnd" /></th>
              <th scope="colgroup" className="text-center" colSpan={arrowsSetNum}><Label data="HeaderArrows" /></th>
              <th scope="colgroup" className="text-center w-10" rowSpan="2"><Label data="HeaderScore" /></th>
              <th scope="colgroup" className="text-center" colSpan="2" rowSpan="2"><Label data="HeaderTotalScore" /></th>
              <th scope="colgroup" className="text-center w-5" rowSpan="2"><Label data="HeaderEnd" /></th>
              <th scope="colgroup" className="text-center" colSpan={arrowsSetNum}><Label data="HeaderArrows" /></th>
              <th scope="colgroup" className="text-center w-10" rowSpan="2"><Label data="HeaderScore" /></th>
              <th rowSpan="2"></th>
            </tr>
            <tr>
              {listArrowsSets}
              {listArrowsSets}
            </tr>
          </thead>
          <tbody>
            {dataFilter && dataFilter?.map((item, key) => {
              let arrowsHome = [];
              let arrowsAway = [];
              let arrowShotHome = [];
              let arrowShotAway = [];
              for (let i = 1; i <= arrowsSetNum; i++) {
                arrowsHome.push(<td className="text-center" key={'arrowHome-' + key + i} >{item['arrowHomeCompe' + i]}{item['arrowHome' + i]}</td>)
                arrowsAway.push(<td className="text-center" key={'arrowAway-' + key + i} >{item['arrowAwayCompe' + i]}{item['arrowAway' + i]}</td>)
                arrowShotHome.push(item['shotHome' + i])
                arrowShotAway.push(item['shotAway' + i])
              }
              let resp = stateRow.settings.find(row => row?.index === item?.set)?.state
              return (
                <React.Fragment key={'olympic-round-team-' + key}>
                  <tr className={`${item?.set === currentPos ? 'currentIndicator' : ''}`}>
                    <td className="text-center">{item?.set}</td>
                    {arrowsHome}
                    <td className="text-center">{item.scoreHome}</td>
                    <td className="text-center">{item.setPointsHome}</td>
                    <td className="text-center">{item.setPointsAway}</td>
                    <td className="text-center">{item?.set}</td>
                    {arrowsAway}
                    <td className="text-center">{item.scoreAway}</td>
                    <td>
                      <span onClick={() => handelClick(item?.set)} aria-controls={'target-set-' + item?.set} aria-expanded={resp}>
                        {//Ñapa para que en Cracovia no tengan dinas
                          mirs_competition === 'OG2024' && <FontAwesomeIcon icon={resp ? faCaretDown : faCaretRight} />}
                      </span>
                    </td>
                  </tr>
                  {resp &&
                    <tr>
                      <td colSpan={parseInt(arrowsSetNum) + 3}>
                        <Target size={sizeTarget} shots={arrowShotHome} />
                        <TargetsModalWindow data={arrowShotHome} />
                      </td>
                      <td colSpan='2'></td>
                      <td colSpan={parseInt(arrowsSetNum) + 3}>
                        <Target size={sizeTarget} shots={arrowShotAway} />
                        <TargetsModalWindow data={arrowShotAway} />
                      </td>
                      <td></td>
                    </tr>
                  }
                </React.Fragment>
              )
            })
            }
          </tbody>
        </table>
      </div>
    </>
  )
}

function OlympicRoundTeamSMPar({ data }) {

  const { mirs_competition } = useUrlFriendlyToParameters()
  const dataFilter = getDataFormated(data)
  let config = data?.results?.extendedInfos
  let sets = config?.find(row => row?.ei_code === 'SET')
  let setsNum = sets?.ei_value;
  let arrows = config?.find(row => row?.ei_code === 'ARROW_NUM')?.ei_value;
  let arrowsSetNum = sets?.extensions?.find(row => row?.eie_code === 'ARROW_NUM' && row?.eie_pos === '1')?.eie_value;
  let listArrowsSets = [];
  let sizeTarget = 100;
  let rowDefault = [];
  const currentPos = data?.results?.extendedInfos.find(row => row?.ei_code === 'CURRENT')?.ei_pos;
  for (let i = 1; i <= setsNum; i++) {
    rowDefault.push({ index: String(i), status: false })
  }
  rowDefault.push({ index: 'SO', status: false })
  const [stateRow, setStateRow] = useState({
    settings: [...rowDefault]
  });


  const handelClick = (set) => {
    setStateRow({
      ...stateRow, settings: stateRow.settings.map(item =>
        item.index === set ? { ...item, state: !item.state } : item
        //{ index: set, state: !stateRow.find(row => row?.index === set) })
      )
    })
  }

  for (let i = 0; i < arrowsSetNum; i++) {
    listArrowsSets.push(<th key={'arrow-' + i} scope="col" className="text-center w-5" > {i + 1}</th >)
  }
  return (
    <>
      <table className="table">
        <caption>
          <div className='d-flex align-items-center'>
            <div className='d-none d-md-block me-1'>
              <Noc {...findArray(data?.results?.items, { startSortOrder: [1] })?.participant?.organisation} />
            </div>
            <strong>
              <Competitor hidePicture={true} {...findArray(data?.results?.items, { startSortOrder: [1] })?.participant} />
            </strong>
          </div>
        </caption>
        <thead>
          <tr>
            <th scope="colgroup" className="text-center w-5" rowSpan="2"><Label data="HeaderEnd" /></th>
            <th scope="colgroup" className="text-center" colSpan={arrowsSetNum}><Label data="HeaderArrows" /></th>
            <th scope="colgroup" className="text-center w-10" rowSpan="2"><Label data="HeaderScore" /></th>
            <th scope="colgroup" className="text-center w-10" rowSpan="2"><Label data="HeaderTotalScore" /></th>
            <th rowSpan="2" className="w-5"></th>
          </tr>
          <tr>
            {listArrowsSets}
          </tr>
        </thead>
        <tbody>
          {dataFilter && dataFilter?.map((item, key) => {
            let arrowsHome = [];
            let arrowShotHome = [];
            for (let i = 1; i <= arrowsSetNum; i++) {
              arrowsHome.push(<td className="text-center" key={'arrowHome-' + key + i} >{item['arrowHomeCompe' + i]}{item['arrowHome' + i]}</td>)
              arrowShotHome.push(item['shotHome' + i])
            }
            let resp = stateRow.settings.find(row => row?.index === item?.set)?.state
            return (
              <React.Fragment key={'olympic-round-team-home' + key}>
                <tr key={'OlympicRoundTeam-' + key} className={`${item?.set === currentPos ? 'currentIndicator' : ''}`}>
                  <td className="text-center">{item?.set}</td>
                  {arrowsHome}
                  <td className="text-center">{item.scoreHome}</td>
                  <td className="text-center">{item.setPointsHome}</td>
                  <td className="text-center">
                    <span onClick={() => handelClick(item?.set)} aria-controls={'target-set-' + item?.set} aria-expanded={resp}>
                      {//Ñapa para que en Cracovia no tengan dinas
                        mirs_competition === 'OG2024' && <FontAwesomeIcon icon={resp ? faCaretDown : faCaretRight} />}
                    </span>
                  </td>
                </tr>
                {resp &&
                  <tr>
                    <td colSpan={parseInt(arrowsSetNum) + 3}>
                      <Target size={sizeTarget} shots={arrowShotHome} />
                      <TargetsModalWindow data={arrowShotHome} />
                    </td>
                    <td></td>
                  </tr>
                }
              </React.Fragment>
            )
          })
          }
        </tbody>
      </table>
      <table className="table">
        <caption>
          <div className='d-flex align-items-center'>
            <div className='d-none d-md-block me-1'>
              <Noc {...findArray(data?.results?.items, { startSortOrder: [2] })?.participant?.organisation} />
            </div>
            <strong>
              <Competitor hidePicture={true} {...findArray(data?.results?.items, { startSortOrder: [2] })?.participant} />
            </strong>
          </div>
        </caption>
        <thead>
          <tr>
            <th scope="colgroup" className="text-center w-5" rowSpan="2"><Label data="HeaderEnd" /></th>
            <th scope="colgroup" className="text-center" colSpan={arrowsSetNum}><Label data="HeaderArrows" /></th>
            <th scope="colgroup" className="text-center w-10" rowSpan="2"><Label data="HeaderScore" /></th>
            <th scope="colgroup" className="text-center w-10" rowSpan="2"><Label data="HeaderTotalScore" /></th>
            <th rowSpan="2" className="w-5"></th>
          </tr>
          <tr>
            {listArrowsSets}
          </tr>
        </thead>
        <tbody>
          {dataFilter && dataFilter?.map((item, key) => {
            let arrowsAway = [];
            let arrowShotAway = [];
            for (let i = 1; i <= arrowsSetNum; i++) {
              arrowsAway.push(<td className="text-center" key={'arrowAway-' + key + i} >{item['arrowAwayCompe' + i]}{item['arrowAway' + i]}</td>)
              arrowShotAway.push(item['shotAway' + i])
            }
            let resp = stateRow.settings.find(row => row?.index === item?.set)?.state
            return (
              <React.Fragment key={'olympic-round-team-away' + key}>
                <tr key={'OlympicRoundTeam-' + key} className={`${item?.set === currentPos ? 'currentIndicator' : ''}`}>
                  <td className="text-center">{item?.set}</td>
                  {arrowsAway}
                  <td className="text-center">{item.scoreAway}</td>
                  <td className="text-center">{item.setPointsAway}</td>
                  <td className="text-center">
                    <span onClick={() => handelClick(item?.set)} aria-controls={'target-set-' + item?.set} aria-expanded={resp}>
                      {//Ñapa para que en Cracovia no tengan dinas
                        mirs_competition === 'OG2024' && <FontAwesomeIcon icon={resp ? faCaretDown : faCaretRight} />}
                    </span>
                  </td>
                </tr>
                {resp &&
                  <tr>
                    <td colSpan={parseInt(arrowsSetNum) + 3}>
                      <Target size={sizeTarget} shots={arrowShotAway} />
                      <TargetsModalWindow data={arrowShotAway} />
                    </td>
                    <td></td>
                  </tr>
                }
              </React.Fragment>
            )
          })
          }
        </tbody>
      </table>
    </>
  )
}

function OlympicRoundTeamXL({ data }) {
  const dataFilter = getDataFormated(data)
  const { mirs_competition } = useUrlFriendlyToParameters()
  let config = data?.results?.extendedInfos
  let sets = config?.find(row => row?.ei_code === 'SET')
  let setsNum = sets?.ei_value;
  let arrows = config?.find(row => row?.ei_code === 'ARROW_NUM')?.ei_value;
  let arrowsSetNum = sets?.extensions?.find(row => row?.eie_code === 'ARROW_NUM' && row?.eie_pos === '1')?.eie_value;
  let listArrowsSets = [];
  let sizeTarget = 300;
  let rowDefault = []
  const currentPos = data?.results?.extendedInfos.find(row => row?.ei_code === 'CURRENT')?.ei_pos;
  for (let i = 1; i <= setsNum; i++) {
    rowDefault.push({ index: String(i), status: false })
  }
  rowDefault.push({ index: 'SO', status: false })
  const [stateRow, setStateRow] = useState({
    settings: [...rowDefault]
  });

  const handelClick = (set) => {
    setStateRow({
      ...stateRow, settings: stateRow.settings.map(item =>
        item.index === set ? { ...item, state: !item.state } : item
        //{ index: set, state: !stateRow.find(row => row?.index === set) })
      )
    })
  }

  for (let i = 0; i < arrowsSetNum; i++) {
    listArrowsSets.push(<th key={'arrow-' + i} scope="col" className="text-center w-5" > {i + 1}</th >)
  }

  return (
    <>
      <div className="mirs-page-container">
        <table className="table">
          <thead>
            <tr>
              <th scope="colgroup" className="text-center w-5" rowSpan="2"><Label data="HeaderSet" /></th>
              <th scope="colgroup" className="text-center" colSpan={arrowsSetNum}><Label data="HeaderArrows" /></th>
              <th scope="colgroup" className="text-center w-10" colSpan="2"><Label data="HeaderTotals" /></th>
              <th scope="colgroup" className="text-center" colSpan="2" rowSpan="2"><Label data="HeaderSetPoints" /></th>
              <th scope="colgroup" className="text-center w-5" rowSpan="2"><Label data="HeaderSet" /></th>
              <th scope="colgroup" className="text-center" colSpan={arrowsSetNum}><Label data="HeaderArrows" /></th>
              <th scope="colgroup" className="text-center w-10" colSpan="2"><Label data="HeaderTotals" /></th>
              <th rowSpan="2"></th>
            </tr>
            <tr>
              {listArrowsSets}
              <th scope="col" className="text-center"><Label data="HeaderScore" /></th>
              <th scope="col" className="text-center"><Label data="HeaderPoints" /></th>
              {listArrowsSets}
              <th scope="col" className="text-center"><Label data="HeaderScore" /></th>
              <th scope="col" className="text-center"><Label data="HeaderPoints" /></th>
            </tr>
          </thead>
          <tbody>
            {dataFilter && dataFilter?.map((item, key) => {
              let arrowsHome = [];
              let arrowsAway = [];
              let arrowShotHome = [];
              let arrowShotAway = [];
              for (let i = 1; i <= arrowsSetNum; i++) {
                arrowsHome.push(<td key={'arrowHome-' + key + i} >{item['arrowHome' + i] && item['arrowHomeCompe' + i]}{item['arrowHome' + i]}</td>)
                arrowsAway.push(<td key={'arrowAway-' + key + i} >{item['arrowAway' + i] && item['arrowAwayCompe' + i]}{item['arrowAway' + i]}</td>)
                arrowShotHome.push(item['shotHome' + i])
                arrowShotAway.push(item['shotAway' + i])
              }
              let resp = stateRow.settings.find(row => row?.index === item?.set)?.state

              return (
                <React.Fragment key={'olympic-round-team-' + key}>
                  <tr className={`${item?.set === currentPos ? 'currentIndicator' : ''}`}>
                    <td>{item?.set}</td>
                    {arrowsHome}
                    <td>{item.scoreHome}</td>
                    <td>{item.pointsHome}</td>
                    <td>{item.setPointsHome}</td>
                    <td>{item.setPointsAway}</td>
                    <td>{item?.set}</td>
                    {arrowsAway}
                    <td>{item.scoreAway}</td>
                    <td>{item.pointsAway}</td>
                    <td>
                      <span onClick={() => handelClick(item?.set)} aria-controls={'target-set-' + item?.set} aria-expanded={resp}>
                        {//Ñapa para que en Cracovia no tengan dinas
                          mirs_competition === 'OG2024' && <FontAwesomeIcon icon={resp ? faCaretDown : faCaretRight} />}
                      </span>
                    </td>
                  </tr>
                  {resp &&
                    <tr>
                      <td colSpan={parseInt(arrowsSetNum) + 3}>
                        <Target size={sizeTarget} shots={arrowShotHome} />
                        <TargetsModalWindow data={arrowShotHome} />
                      </td>
                      <td colSpan='2'></td>
                      <td colSpan={parseInt(arrowsSetNum) + 3}>
                        <Target size={sizeTarget} shots={arrowShotAway} />
                        <TargetsModalWindow data={arrowShotAway} />
                      </td>
                      <td></td>
                    </tr>
                  }
                </React.Fragment>
              )
            })
            }
          </tbody>
        </table>
      </div>
    </>
  )
}

function OlympicRoundTeamSM({ data }) {
  const { mirs_competition } = useUrlFriendlyToParameters()
  const dataFilter = getDataFormated(data)
  let config = data?.results?.extendedInfos
  let sets = config?.find(row => row?.ei_code === 'SET')
  let setsNum = sets?.ei_value;
  let arrows = config?.find(row => row?.ei_code === 'ARROW_NUM')?.ei_value;
  let arrowsSetNum = sets?.extensions?.find(row => row?.eie_code === 'ARROW_NUM' && row?.eie_pos === '1')?.eie_value;
  let listArrowsSets = [];
  let sizeTarget = 100;
  let rowDefault = [];
  const currentPos = data?.results?.extendedInfos.find(row => row?.ei_code === 'CURRENT')?.ei_pos;
  for (let i = 1; i <= setsNum; i++) {
    rowDefault.push({ index: String(i), status: false })
  }
  rowDefault.push({ index: 'SO', status: false })
  const [stateRow, setStateRow] = useState({
    settings: [...rowDefault]
  });


  const handelClick = (set) => {
    setStateRow({
      ...stateRow, settings: stateRow.settings.map(item =>
        item.index === set ? { ...item, state: !item.state } : item
        //{ index: set, state: !stateRow.find(row => row?.index === set) })
      )
    })
  }

  for (let i = 0; i < arrowsSetNum; i++) {
    listArrowsSets.push(<th key={'arrow-' + i} scope="col" className="text-center w-5" > {i + 1}</th >)
  }
  return (
    <>
      <table className="table">
        <caption>
          <div className='d-flex align-items-center'>
            <div className='d-none d-md-block me-1'>
              <Noc {...findArray(data?.results?.items, { startSortOrder: [1] })?.participant?.organisation} />
            </div>
            <strong>
              <Competitor hidePicture={true} {...findArray(data?.results?.items, { startSortOrder: [1] })?.participant} />
            </strong>
          </div>
        </caption>
        <thead>
          <tr>
            <th scope="colgroup" className="text-center w-5" rowSpan="2"><Label data="HeaderSet" /></th>
            <th scope="colgroup" className="text-center" colSpan={arrowsSetNum}><Label data="HeaderArrows" /></th>
            <th scope="colgroup" className="text-center w-10" colSpan="2"><Label data="HeaderTotals" /></th>
            <th scope="colgroup" className="text-center w-10" rowSpan="2"><Label data="HeaderSetPoints" /></th>
            <th rowSpan="2" className="w-5"></th>
          </tr>
          <tr>
            {listArrowsSets}
            <th scope="col" className="text-center"><Label data="HeaderScore" /></th>
            <th scope="col" className="text-center"><Label data="HeaderPoints" /></th>
          </tr>
        </thead>
        <tbody>
          {dataFilter && dataFilter?.map((item, key) => {
            let arrowsHome = [];
            let arrowShotHome = [];
            for (let i = 1; i <= arrowsSetNum; i++) {
              arrowsHome.push(<td key={'arrowHome-' + key + i} >{item['arrowHomeCompe' + i]}{item['arrowHome' + i]}</td>)
              arrowShotHome.push(item['shotHome' + i])
            }
            let resp = stateRow.settings.find(row => row?.index === item?.set)?.state
            return (
              <React.Fragment key={'olympic-round-team-home' + key}>
                <tr key={'OlympicRoundTeam-' + key} className={`${item?.set === currentPos ? 'currentIndicator' : ''}`}>
                  <td>{item?.set}</td>
                  {arrowsHome}
                  <td>{item.scoreHome}</td>
                  <td>{item.pointsHome}</td>
                  <td>{item.setPointsHome}</td>
                  <td>
                    <span onClick={() => handelClick(item?.set)} aria-controls={'target-set-' + item?.set} aria-expanded={resp}>
                      {//Ñapa para que en Cracovia no tengan dinas
                        mirs_competition === 'OG2024' && <FontAwesomeIcon icon={resp ? faCaretDown : faCaretRight} />}
                    </span>
                  </td>
                </tr>
                {resp &&
                  <tr>
                    <td colSpan={parseInt(arrowsSetNum) + 3}>
                      <Target size={sizeTarget} shots={arrowShotHome} />
                      <TargetsModalWindow data={arrowShotHome} />
                    </td>
                    <td></td>
                  </tr>
                }
              </React.Fragment>
            )
          })
          }
        </tbody>
      </table>
      <table className="table">
        <caption>
          <div className='d-flex align-items-center'>
            <div className='d-none d-md-block me-1'>
              <Noc {...findArray(data?.results?.items, { startSortOrder: [2] })?.participant?.organisation} />
            </div>
            <strong>
              <Competitor hidePicture={true} {...findArray(data?.results?.items, { startSortOrder: [2] })?.participant} />
            </strong>
          </div>
        </caption>
        <thead>
          <tr>
            <th scope="colgroup" className="text-center w-5" rowSpan="2"><Label data="HeaderSet" /></th>
            <th scope="colgroup" className="text-center" colSpan={arrowsSetNum}><Label data="HeaderArrows" /></th>
            <th scope="colgroup" className="text-center w-10" colSpan="2"><Label data="HeaderTotals" /></th>
            <th scope="colgroup" className="text-center w-10" rowSpan="2"><Label data="HeaderSetPoints" /></th>
            <th rowSpan="2" className="w-5"></th>
          </tr>
          <tr>
            {listArrowsSets}
            <th scope="col" className="text-center"><Label data="HeaderScore" /></th>
            <th scope="col" className="text-center"><Label data="HeaderPoints" /></th>
          </tr>
        </thead>
        <tbody>
          {dataFilter && dataFilter?.map((item, key) => {
            let arrowsAway = [];
            let arrowShotAway = [];
            for (let i = 1; i <= arrowsSetNum; i++) {
              arrowsAway.push(<td key={'arrowAway-' + key + i} >{item['arrowAwayCompe' + i]}{item['arrowAway' + i]}</td>)
              arrowShotAway.push(item['shotAway' + i])
            }
            let resp = stateRow.settings.find(row => row?.index === item?.set)?.state
            return (
              <React.Fragment key={'olympic-round-team-away' + key}>
                <tr key={'OlympicRoundTeam-' + key} className={`${item?.set === currentPos ? 'currentIndicator' : ''}`} >
                  <td>{item?.set}</td>
                  {arrowsAway}
                  <td>{item.scoreAway}</td>
                  <td>{item.pointsAway}</td>
                  <td>{item.setPointsAway}</td>
                  <td>
                    <span onClick={() => handelClick(item?.set)} aria-controls={'target-set-' + item?.set} aria-expanded={resp}>
                      {//Ñapa para que en Cracovia no tengan dinas
                        mirs_competition === 'OG2024' && <FontAwesomeIcon icon={resp ? faCaretDown : faCaretRight} />}
                    </span>
                  </td>
                </tr>
                {resp &&
                  <tr>
                    <td colSpan={parseInt(arrowsSetNum) + 3}>
                      <Target size={sizeTarget} shots={arrowShotAway} />
                      <TargetsModalWindow data={arrowShotAway} />
                    </td>
                    <td></td>
                  </tr>
                }
              </React.Fragment>
            )
          })
          }
        </tbody>
      </table>
    </>
  )
}

function getDataFormated(data) {
  let config = data?.results?.extendedInfos
  let sets = config?.find(row => row?.ei_code === 'SET')?.extensions;

  const arrowsSets = config?.find(item => item.ei_code === 'ARROW_SET')?.extensions.filter(extension => extension.eie_code === 'ARROW_ID').sort((a, b) => a.eie_pos - b.eie_pos);
  const arrowsSetTB = config?.find(item => item.ei_code === 'ARROW_SETTB')?.extensions.filter(extension => extension.eie_code === 'ARROW_ID').sort((a, b) => a.eie_pos - b.eie_pos);

  let dataArray = [];
  let dataHome = data?.results?.items?.find(row => row?.startSortOrder === 1);
  let dataAway = data?.results?.items?.find(row => row?.startSortOrder === 2);;
  sets.map(set => {

    let arrows = arrowsSets.filter(arrow => arrow.eie_value === set.eie_pos)
    let numSet = String(set?.eie_pos);

    let setValuesHome = dataHome?.extendedResults?.find(res => res?.er_code === 'SET' && res?.er_pos === numSet)
    let setValuesAway = dataAway?.extendedResults?.find(res => res?.er_code === 'SET' && res?.er_pos === numSet)

    let line = {
      set: numSet,
      pointsHome: setValuesHome?.er_value,
      scoreHome: setValuesHome?.extensions?.find(ext => ext.ere_code === 'ARROW_TOT')?.ere_value,
      setPointsHome: setValuesHome?.extensions?.find(ext => ext.ere_code === 'CUMULATIVE')?.ere_value,
      pointsAway: setValuesAway?.er_value,
      scoreAway: setValuesAway?.extensions?.find(ext => ext.ere_code === 'ARROW_TOT')?.ere_value,
      setPointsAway: setValuesAway?.extensions?.find(ext => ext.ere_code === 'CUMULATIVE')?.ere_value,
    }
    arrows.map((arrow, index) => {
      let keyHome = 'arrowHome' + (index + 1);
      let keyAway = 'arrowAway' + (index + 1);
      let keyHomeCompe = 'arrowHomeCompe' + (index + 1);
      let keyAwayCompe = 'arrowAwayCompe' + (index + 1);
      let arrowHome = dataHome?.extendedResults?.find(res => res?.er_code === 'ARROW' && res?.er_pos === arrow?.eie_pos);
      let arrowAway = dataAway?.extendedResults?.find(res => res?.er_code === 'ARROW' && res?.er_pos === arrow?.eie_pos);

      let arrowHomeUnchecked = dataHome?.extendedResults?.find(res => res?.er_code === 'ARROW' && res?.er_pos === arrow?.eie_pos)?.er_unchecked;
      let arrowAwayUnchecked = dataAway?.extendedResults?.find(res => res?.er_code === 'ARROW' && res?.er_pos === arrow?.eie_pos)?.er_unchecked;
      arrowHomeUnchecked = arrowHomeUnchecked === 'Y' && '*'
      arrowAwayUnchecked = arrowAwayUnchecked === 'Y' && '*'

      line[keyHome] = <>{arrowHome?.er_value} {arrowHomeUnchecked && arrowHomeUnchecked}</>
      line[keyAway] = <>{arrowAway?.er_value} {arrowAwayUnchecked && arrowAwayUnchecked}</>

      let AthCodeHome = arrowHome?.er_value2
      line[keyHomeCompe] = <AthleteGeometric data={dataHome?.teamAthletes} code={AthCodeHome} />

      let AthCodeAway = arrowAway?.er_value2
      line[keyAwayCompe] = <AthleteGeometric data={dataAway?.teamAthletes} code={AthCodeAway} />

      let shotHome = {
        codeX: arrowHome?.extensions?.find(shot => shot?.ere_code === 'X')?.ere_value,
        codeY: arrowHome?.extensions?.find(shot => shot?.ere_code === 'Y')?.ere_value,
        codeDIAM: arrowHome?.extensions?.find(shot => shot?.ere_code === 'DIAM')?.ere_value,
      }
      line['shotHome' + (index + 1)] = shotHome;
      let shotAway = {
        codeX: arrowAway?.extensions?.find(shot => shot?.ere_code === 'X')?.ere_value,
        codeY: arrowAway?.extensions?.find(shot => shot?.ere_code === 'Y')?.ere_value,
        codeDIAM: arrowAway?.extensions?.find(shot => shot?.ere_code === 'DIAM')?.ere_value,
      }
      line['shotAway' + (index + 1)] = shotAway;
    }
    )
    dataArray.push(
      line
    )

  })

  if (arrowsSetTB) {
    let setTBNum = config?.find(item => item.ei_code === 'ARROW_SETTB')?.ei_value
    let setValuesHome = dataHome?.extendedResults?.find(res => res?.er_code === 'TIE_BREAK' && res?.er_pos === setTBNum)
    let setValuesAway = dataAway?.extendedResults?.find(res => res?.er_code === 'TIE_BREAK' && res?.er_pos === setTBNum)
    let lineTB = {
      set: 'SO',
      pointsHome: setValuesHome?.er_value,
      pointsHome: setValuesHome?.extensions?.find(ext => ext.ere_code === 'TB_SET')?.ere_value,
      setPointsHome: setValuesHome?.extensions?.find(ext => ext.ere_code === 'CUMULATIVE')?.ere_value,
      pointsAway: setValuesAway?.er_value,
      pointsAway: setValuesAway?.extensions?.find(ext => ext.ere_code === 'TB_SET')?.ere_value,
      setPointsAway: setValuesAway?.extensions?.find(ext => ext.ere_code === 'CUMULATIVE')?.ere_value,
    }
    let homePlus = '';
    let awayPlus = '';
    arrowsSetTB.map((arrow, index) => {
      let keyHome = 'arrowHome' + (index + 1);
      let keyAway = 'arrowAway' + (index + 1);
      let keyHomeCompe = 'arrowHomeCompe' + (index + 1);
      let keyAwayCompe = 'arrowAwayCompe' + (index + 1);
      let home = dataHome?.extendedResults?.find(res => res?.er_code === 'TB_ARROW' && res?.er_pos === arrow?.eie_pos)
      let away = dataAway?.extendedResults?.find(res => res?.er_code === 'TB_ARROW' && res?.er_pos === arrow?.eie_pos)

      let closestHome = home?.extensions?.find(res => res?.ere_code === 'CLOSEST')
      let sHome = closestHome?.ere_value?.replace('Y', '+')
      homePlus = (closestHome && homePlus !== '+') ? sHome : ''

      let closestAway = away?.extensions?.find(res => res?.ere_code === 'CLOSEST')
      let sAway = closestAway?.ere_value?.replace('Y', '+')
      awayPlus = (closestAway && homePlus !== '+') ? sAway : ''

      lineTB[keyHome] = (home?.er_value)?.replace(undefined, '')
      lineTB[keyAway] = (away?.er_value)?.replace(undefined, '')

      let AthCodeHome = dataHome?.extendedResults?.find(res => res?.er_code === 'ARROW' && res?.er_pos === arrow?.eie_pos)?.er_value2
      lineTB[keyHomeCompe] = <AthleteGeometric data={dataHome?.teamAthletes} code={AthCodeHome} />

      let AthCodeAway = dataAway?.extendedResults?.find(res => res?.er_code === 'ARROW' && res?.er_pos === arrow?.eie_pos)?.er_value2
      lineTB[keyAwayCompe] = <AthleteGeometric data={dataAway?.teamAthletes} code={AthCodeAway} />

      let shotHome = {
        codeX: home?.extensions?.find(shot => shot?.ere_code === 'X')?.ere_value,
        codeY: home?.extensions?.find(shot => shot?.ere_code === 'Y')?.ere_value,
        codeDIAM: home?.extensions?.find(shot => shot?.ere_code === 'DIAM')?.ere_value,
      }
      lineTB['shotHome' + (index + 1)] = shotHome;
      let shotAway = {
        codeX: away?.extensions?.find(shot => shot?.ere_code === 'X')?.ere_value,
        codeY: away?.extensions?.find(shot => shot?.ere_code === 'Y')?.ere_value,
        codeDIAM: away?.extensions?.find(shot => shot?.ere_code === 'DIAM')?.ere_value,
      }
      lineTB['shotAway' + (index + 1)] = shotAway;
    }
    )
    dataArray.push(
      lineTB
    )

    lineTB['scoreAway'] = setValuesAway?.er_value && (setValuesAway?.er_value + awayPlus)
    lineTB['scoreHome'] = setValuesHome?.er_value && (setValuesHome?.er_value + homePlus)
  }
  return (
    dataArray
  )
}

function AthleteGeometric({ code, data }) {
  let cuadrado = data?.find(row => row.order === 1)
  let triangulo = data?.find(row => row.order === 2)
  let circulo = data?.find(row => row.order === 3)
  let figure = '  ';
  if (cuadrado?.athlete?.code === code && code) {
    figure = <FontAwesomeIcon className='align-self-center' icon={faStop} />
  } else if (triangulo?.athlete?.code === code && code) {
    figure = <FontAwesomeIcon className='align-self-center' icon={faCaretUp} />
  } else if (circulo?.athlete?.code === code && code) {
    figure = <FontAwesomeIcon className='align-self-center' icon={faCircle} />
  }

  return (
    <>
      <div>{figure}</div>
    </>
  )
}

export default OlympicRoundTeam;